const DISMISS_KEY = 'bcn_pwa_install_dismissed'
const DISMISS_MS = 14 * 24 * 60 * 60 * 1000

export const isStandalonePwa = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true ||
  document.referrer.includes('android-app://')

export const isIosDevice = () =>
  /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream

export const isAndroidDevice = () => /Android/i.test(navigator.userAgent)

export const isIosChrome = () => /CriOS/i.test(navigator.userAgent)

export const isIosSafari = () =>
  isIosDevice() &&
  /Safari/i.test(navigator.userAgent) &&
  !/CriOS|FxiOS|EdgiOS/i.test(navigator.userAgent)

export const isIosInstallableBrowser = () => isIosDevice() && !isStandalonePwa()

export const isInstallPromptDismissed = () => {
  try {
    const raw = localStorage.getItem(DISMISS_KEY)
    if (!raw) return false
    const dismissedAt = Number(raw)
    if (Number.isNaN(dismissedAt)) return false
    return Date.now() - dismissedAt < DISMISS_MS
  } catch {
    return false
  }
}

export const dismissInstallPrompt = () => {
  try {
    localStorage.setItem(DISMISS_KEY, String(Date.now()))
  } catch {
    // ignore storage errors
  }
}
